export const version = "abstract-provider/5.0.7";
//# sourceMappingURL=_version.js.map